var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ml-4",attrs:{"items":_vm.itemCourses,"chips":"","deletable-chips":"","item-text":"name","item-value":"id","menu-props":"auto","placeholder":"Wszystkie kierunki","single-line":""},model:{value:(_vm.courseSingleSelected),callback:function ($$v) {_vm.courseSingleSelected=$$v},expression:"courseSingleSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }